import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';
import { IAuthFactors, IAuthOperationResponse } from '@utils/interfaces/response/auth-factors.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../auth/auth.service';
import { DocumentType } from '@domain/model/enums/document-type/document-type.enum';

@Injectable({
  providedIn: 'root',
})
export class BiometryService {
  constructor(private http: HttpClient, private readonly authService: AuthService) {}

  fetchAuthFactorTokenInfo(documentNumber: string, documentType: DocumentType): Observable<IAuthFactors> {
    const body = {
      identityDocument: {
        number: documentNumber,
        type: documentType
      }
    }
    return this.http.post<IAuthFactors>(`${environment.bffAuthFactorsInfo}`, body , {
      params: {
        type: 'BUSINESS-ACCOUNTS'
      },
      headers: this.authService.buildHeaders(),
    });
  }
  fetchAuthOperation(transactionId: string, documentNumber: string, documentType: DocumentType): Observable<boolean> {
    const body = {
      documentNumber: documentNumber,
      documentType: documentType
    }
    
    return this.http
      .post<IAuthOperationResponse>(`${environment.bffIdentityAuthAdapterStatus}`, body ,{
        params: { 
          transactionId: transactionId 
        },
        headers: this.authService.buildHeaders(),
      })
      .pipe(map(({ status }) => status === 'ACCEPTED'));
  }
}
